console.log('[Felljoy] cookie-settings.js loaded');

document.addEventListener('DOMContentLoaded', function() {
  var cookieLinks = document.querySelectorAll('a[href*="cookie-consent"]');
  cookieLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.showPreferences();
      }
    });
  });
});
